const swiper = new Swiper(".mySwiper", {
    loop: false,
    spaceBetween: 24,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        0: {
            slidesPerView: 1.2, 
            slidesPerGroup: 1,
        },
        576: {
            slidesPerView: 2, 
            slidesPerGroup: 2,
        },
        768: {
            slidesPerView: 3, 
            slidesPerGroup: 3,
        },
    },
});